import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { Feature } from '@frontend/functionality/types';
import React from 'react';

import useFeatureSelect from './feature-select.controller';

const ID = 'feature-select';
export interface FeatureSelectProps extends Omit<SelectInputV2Props<Feature>, 'options'> {
    subset?: string[];
}

export const FeatureSelect = (props: FeatureSelectProps) => {
    const viewProps = useFeatureSelect(props);

    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Feature'}
            options={props.subset ? props.subset.map((s) => ({ value: s, label: s })) : viewProps.options}
        />
    );
};

export default FeatureSelect;
